var map = {
	"./feature_buy_cn.png": 18184,
	"./feature_buy_en.png": 16505,
	"./feature_buy_id.png": 28679,
	"./feature_buy_ko.png": 43402,
	"./feature_buy_th.png": 70228,
	"./feature_buy_zh.png": 45821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76459;